/**
 * Converts an email address to a formatted display name
 * Example: "k.harish@maersk.com" -> "K Harish"
 * @param {string} email - The email address
 * @returns {string} - Formatted display name
 */
export const formatEmailToName = (email) => {
  if (!email || typeof email !== 'string') {
    return 'Not Yet Assigned';
  }

  // Extract the part before @
  const username = email.split('@')[0];
  
  // Split by dots or underscores
  const nameParts = username.split(/[._-]/);
  
  // Capitalize each part
  const formattedName = nameParts
    .map(part => {
      if (!part) return '';
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    })
    .filter(part => part.length > 0)
    .join(' ');
  
  return formattedName || email;
};
